module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTUzNy40IDY2MS43bDIuMi0yLjUgMjQ5LjktMjQ3YTM1IDM1IDAgMCAwIDAtNDkuOSAzNiAzNiAwIDAgMC00Ny4xLTIuOWwtMy40IDNMNTEyIDU4Ni43bC0yMjctMjI0LjRhMzYgMzYgMCAwIDAtNDcuMS0zbC0zLjQgM2EzNSAzNSAwIDAgMCAwIDQ5LjlsMjQ5LjkgMjQ3IDIuMyAyLjVjNi40IDYuNCAxNC43IDkuOCAyMy4xIDEwLjNoNC41YTM1LjggMzUuOCAwIDAgMCAxOS44LTcuM2wzLjQtMi45eiIgZmlsbD0iIzAiIHAtaWQ9IjYzMSI+PC9wYXRoPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Chevron down-outlined.svg
// module id = y4RZ
// module chunks = 75